import { ConnectionPositionPair } from '@angular/cdk/overlay';
import {
    DATIQ_INPUT_BUTTON,
    datiqInputCreateId
} from '@dat/datiq-core/models';

export const DATIQ_PANEL_POPUP_POSITION_LEFT_BOTTOM =
    new ConnectionPositionPair(
        { originX: 'start', originY: 'bottom' },
        { overlayX: 'start', overlayY: 'top' }
    );

export const DATIQ_PANEL_POPUP_POSITION_RIGHT_BOTTOM =
    new ConnectionPositionPair(
        { originX: 'end', originY: 'bottom' },
        { overlayX: 'end', overlayY: 'top' }
    );

export const DATIQ_PANEL_POPUP_POSITION_LEFT_TOP = new ConnectionPositionPair(
    { originX: 'start', originY: 'top' },
    { overlayX: 'start', overlayY: 'bottom' }
);

export const DATIQ_PANEL_POPUP_POSITION_RIGHT_TOP = new ConnectionPositionPair(
    { originX: 'end', originY: 'top' },
    { overlayX: 'end', overlayY: 'bottom' }
);

export const DATIQ_PANEL_POPUP_POSITION_UNDER_LABEL =
    new ConnectionPositionPair(
        { originX: 'start', originY: 'bottom' },
        { overlayX: 'center', overlayY: 'top' }
    );

export const DATIQ_PANEL_POPUP_CONNECTION_LEFT_BOTTOM: ConnectionPositionPair[] =
    [
        DATIQ_PANEL_POPUP_POSITION_LEFT_BOTTOM,
        DATIQ_PANEL_POPUP_POSITION_RIGHT_BOTTOM,
        DATIQ_PANEL_POPUP_POSITION_LEFT_TOP,
        DATIQ_PANEL_POPUP_POSITION_RIGHT_TOP,
    ];

export const DATIQ_PANEL_POPUP_CONNECTION_RIGHT_BOTTOM: ConnectionPositionPair[] =
    [
        DATIQ_PANEL_POPUP_POSITION_RIGHT_BOTTOM,
        DATIQ_PANEL_POPUP_POSITION_LEFT_BOTTOM,
        DATIQ_PANEL_POPUP_POSITION_RIGHT_TOP,
        DATIQ_PANEL_POPUP_POSITION_LEFT_TOP,
    ];

export const DATIQ_PANEL_POPUP_CONNECTION_UNDER_LABEL: ConnectionPositionPair[] =
    [DATIQ_PANEL_POPUP_POSITION_UNDER_LABEL];

export const DATIQ_PANEL_POPUP_ID_BUTTON_TRIGGER: (id: string) => string = (
    id: string
) => datiqInputCreateId([id, DATIQ_INPUT_BUTTON, 'trigger']);
export const DATIQ_PANEL_POPUP_ID_BUTTON_CLOSE: (id: string) => string = (
    id: string
) => datiqInputCreateId([id, DATIQ_INPUT_BUTTON, 'close']);

export const DATIQ_PANEL_POPUP_DEFAULT_ICON: string = 'app:edit';
export const DATIQ_PANEL_POPUP_DEFAULT_ICON_CLOSE: string = 'app:close';
export const DATIQ_PANEL_POPUP_DEFAULT_ICON_DISABLED: string = 'app:lock';
export const DATIQ_PANEL_POPUP_DEFAULT_ICON_ERROR: string = 'app:error';
export const DATIQ_PANEL_POPUP_DEFAULT_ICON_FIXED = 'app:filled-check';
